import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class KaspiSettingsValidator {

    merchantId = [
        Validators.required
    ];

    apikey = [
        Validators.required
    ];

    company = [
        Validators.required
    ]

    url = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        merchantId: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        apikey: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        company: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        url: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}